import React, { useState } from 'react';

import './Input.scss';
import {InputLog} from "../../services/interactions/elements/input";

function InputPassword({ placeholder, label, value, onChange, onBlur, onClick, disabled, error }) {
    const [isFocused, setIsFocused] = useState(false);
    const [isRevealed, setIsRevealed] = useState(false);

    const _onClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    }
    const _onBlur = () => {
        setIsFocused(false);
        if (onBlur) {
            onBlur();
        }
    }
    const _onFocus = (e) => {
        setIsFocused(true);
    }
    const _onChange = (e) => {
        onChange(e.target.value);
    }

    const _reveal = (b) => () => {
        setIsRevealed(b);
    }

    return (
        <div className={`InputComponent password ${isFocused ? 'focused' : ''} ${(!!value || isFocused) ? 'dirty' : ''} ${error ? 'error' : ''}`}>
            {
                label ?
                    <label>
                        {label}
                    </label>
                    : ''
            }
            <div className="inputHolster">
                <input
                    value={value}
                    type={isRevealed ? "text" :"password"}
                    onClick={_onClick}
                    onBlur={_onBlur}
                    onFocus={_onFocus}
                    onChange={_onChange}
                    disabled={disabled || false}
                    placeholder={placeholder}
                />
                <div onMouseDown={_reveal(true)} onMouseUp={_reveal(false)} className="visibility">
                    {
                        isRevealed ?
                            <span className="material-icons">
                                visibility_off
                    </span>
                            :
                            <span className="material-icons">
                                visibility
                    </span>
                    }
                </div>
            </div>
            {
                error ?
                    <span className="error">
                        {error}
                    </span>
                    : ''
            }
            <div className="_border"></div>
        </div>
    )
}

export default InputLog(InputPassword);
